var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCompactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.7,382.3h206.5c6.6,0,12-5.4,12-12v-143.7c0-6.6-5.4-12-12-12h-206.5c-6.6,0-12,5.4-12,12v143.7c0,6.6,5.4,12,12,12ZM190.7,226.7c0-3.3,2.7-6,6-6h206.5c3.3,0,6,2.7,6,6v143.7c0,3.3-2.7,6-6,6h-206.5c-3.3,0-6-2.7-6-6v-143.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.2,80h-254.4c-6.6,0-12,5.4-12,12v416.1c0,6.6,5.4,12,12,12h254.4c6.6,0,12-5.4,12-12V92c0-6.6-5.4-12-12-12ZM433.2,508c0,3.3-2.7,6-6,6h-254.4c-3.3,0-6-2.7-6-6v-101.8h266.4v101.8ZM433.2,400.3H166.8v-197.6h266.4v197.6ZM172.8,86h254.4c3.3,0,6,2.7,6,6v104.8H166.8v-104.8c0-3.3,2.7-6,6-6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7,178.8h3c6.6,0,12-5.4,12-12v-50.9c0-6.6-5.4-12-12-12h-3c-6.6,0-12,5.4-12,12v50.9c0,6.6,5.4,12,12,12ZM190.7,115.9c0-3.3,2.7-6,6-6h3c3.3,0,6,2.7,6,6v50.9c0,3.3-2.7,6-6,6h-3c-3.3,0-6-2.7-6-6v-50.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.5,178.8c8.3,0,15-6.7,15-15s-6.7-15-15-15-15,6.7-15,15,6.7,15,15,15ZM295.5,154.8c5,0,9,4,9,9s-4,9-9,9-9-4-9-9,4-9,9-9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.9,178.8c8.3,0,15-6.7,15-15s-6.7-15-15-15-15,6.7-15,15,6.7,15,15,15ZM347.9,154.8c5,0,9,4,9,9s-4,9-9,9-9-4-9-9,4-9,9-9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400.3,178.8c8.3,0,15-6.7,15-15s-6.7-15-15-15-15,6.7-15,15,6.7,15,15,15ZM400.3,154.8c5,0,9,4,9,9s-4,9-9,9-9-4-9-9,4-9,9-9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCompactor);
export default __webpack_public_path__ + "static/media/trash-compactor.a30fb90159a77b895e8b445a274482b5.svg";
export { ForwardRef as ReactComponent };